export enum InviteStatus {
    Pending = 'pending',
    Accepted = 'accepted',
}
